export function coordTransformToCtx(ctx, x, y, zoom = undefined) {
	let width = ctx.canvas.width;
	let height = ctx.canvas.height;
	y = -y; // Turn upsida down
	if (zoom && zoom.ratio !== 1) {
		x -= zoom.x;
		y += zoom.y;
		x /= zoom.ratio;
		y /= zoom.ratio;
	}
	x = x * height / 2 + width / 2;
	y = y * height / 2 + height / 2;
	return [x, y];
}

export function coordTransformFromCtx(ctx, x, y) {
	let width = ctx.canvas.width;
	let height = ctx.canvas.height;
	x = (x - width / 2) / (height / 2);
	y = (y - height / 2) / (height / 2);
	return [x, -y];
}

// Simplified function to draw a line
export function drawLine(ctx, x1, y1, x2, y2, style, zoom = undefined) {
	if (x1 != null && y1 != null && ctx != null) {
		ctx.beginPath();
		[x1, y1] = coordTransformToCtx(ctx, x1, y1, zoom);
		[x2, y2] = coordTransformToCtx(ctx, x2, y2, zoom);
		ctx.moveTo(x1, y1);
		ctx.lineTo(x2, y2);
		ctx.strokeStyle = style?.color ? style.color : "#000000";
		ctx.lineWidth = style?.width ? style.width : 1;
		ctx.stroke();
	}
	return [x2, y2];
}

export function clearCtx(ctx) {
	let width = ctx.canvas.clientWidth;
	let height = ctx.canvas.clientHeight;
	if (width === 0) {
		width = ctx.canvas.width;
		height = ctx.canvas.height;
	}
	// console.log("clearCtx", width, height);
	ctx.clearRect(0, 0, width, height);
	// ctx.fillStyle = `rgba(255,255,255,0`;
	// ctx.fillRect(0, 0, width, height);
}

export function fadeCtx(ctx, fade_rate, size_ctx) {
	let width = size_ctx ? size_ctx.canvas.clientWidth : ctx.canvas.clientWidth;
	let height = size_ctx ? size_ctx.canvas.clientHeight : ctx.canvas.clientHeight;
	ctx.fillStyle = `rgba(255,255,255,${fade_rate}`;
	ctx.fillRect(0, 0, width, height);
}

export function drawCircle(ctx, x, y, radius, style, zoom = undefined) {
	let height = ctx.canvas.height;
	[x, y] = coordTransformToCtx(ctx, x, y, zoom)

	let rad = radius;
	if (zoom)
		rad /= zoom.ratio;

	ctx.beginPath();
	ctx.arc(
		x, y,
		rad * height / 2,
		0, 2 * Math.PI);
	ctx.strokeStyle = style?.color ? style.color : "#000000";
	ctx.lineWidth = style?.width ? style.width : 1;
	ctx.stroke();
}
